module.exports = __webpack_public_path__ + "img/brand2.6ede22c0.png";